const formatter = new Intl.NumberFormat('pt-BR', {
  currency: 'BRL',
  currencyDisplay: 'symbol',
  currencySign: 'standard',
  style: 'currency',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  minimumIntegerDigits: 1,
});
const formatterMonetaryValue = (value: number | string | null): string => {
  if (!value) return `${formatter.format(0)}`;

  if (typeof value === 'string') return `${formatter.format(parseFloat(value) || 0)}`;

  return `${formatter.format(value)}`;
};
export default formatterMonetaryValue;
